// NOTE: This mutation uses the GraphQL Upload scalar (multipart file upload).

import gql from 'graphql-tag';

export interface ImportTVTimeMutationVariables {
	file: File;
	readOnly: boolean;
}

export interface ImportTVTimePayload {
	watchlistMatched: number;
	watchlistAdded: number;
	seenlistMatched: number;
	seenlistAdded: number;
}

export interface ImportTVTimeMutation {
	importTVTimeLists: ImportTVTimePayload;
}

export const ImportTVTimeDocument = gql`
	mutation ImportTVTime($file: Upload!, $readOnly: Boolean!) {
		importTVTimeLists(input: { file: $file, readOnly: $readOnly }) {
			watchlistMatched
			watchlistAdded
			seenlistMatched
			seenlistAdded
		}
	}
`;
